// Auth pages (no lazy loading for auth)
import AuthCallback from '@/components/auth/AuthCallback.tsx'
import ProtectedRoute from '@/components/auth/ProtectedRoute'
import { lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

// Lazy load protected pages
const ContactSearch = lazy(() => import('@/app/contacts/search/page'))
const ContactProfile = lazy(() => import('@/app/contacts/profile/[id]/page'))
const ContactCreate = lazy(() => import('@/app/contacts/create/page'))
const ContactEdit = lazy(() => import('@/app/contacts/edit/[id]/page'))
const CompanyProfile = lazy(() => import('@/app/contacts/company-profile/[id]/page'))
const CompanyCreate = lazy(() => import('@/app/contacts/create-company/page'))
const CompanyEdit = lazy(() => import('@/app/contacts/company-edit/[id]/page'))
const LinkContact = lazy(() => import('@/app/contacts/link-contact/[id]/page'))
const LinkCompany = lazy(() => import('@/app/contacts/link-company/[id]/page'))

const AwardsSearch = lazy(() => import('@/app/awards/search/page'))
const AwardsCreate = lazy(() => import('@/app/awards/create/page'))
const AwardsEdit = lazy(() => import('@/app/awards/edit/[id]/page'))

const EntriesSearch = lazy(() => import('@/app/entries/search/page'))
const EntriesProfile = lazy(() => import('@/app/entries/profile/[id]/page'))
const EntriesFinalists = lazy(() => import('@/app/entries/finalists/page'))
const EntriesReveal = lazy(() => import('@/app/entries/reveal/page'))
const EntriesUploadAssets = lazy(() => import('@/app/entries/uploadAssets/page'))

const JudgesSearch = lazy(() => import('@/app/judges/search/page'))

const NominationsSearch = lazy(() => import('@/app/nominations/search/page'))
const NominationsView = lazy(() => import('@/app/nominations/view/[id]/page'))

const EnquiriesSearch = lazy(() => import('@/app/enquiries/search/page'))
const EnquiriesView = lazy(() => import('@/app/enquiries/view/[id]/page'))

const EmployeesAccess = lazy(() => import('@/app/access/employees/page'))

const ReportsSummary = lazy(() => import('@/app/reports/summary-reports/page'))

export function AppRoutes() {
	return (
		<Routes>
			{/* Public routes */}
			{/*<Route path="/auth/logout" element={<LogoutRedirect />} />*/}
			<Route path="/auth/callback" element={<AuthCallback />} />

			{/* To remove as not required. */}
			{/*<Route path="/auth/login" element={<Login />} />*/}
			{/*<Route path="/auth/otplogin" element={<OtpLogin />} />*/}
			{/*<Route path="/auth/create-login" element={<CreateLogin />} />*/}
			{/*<Route path="/auth/forgot-password" element={<ForgotPassword />} />*/}
			{/*<Route path="/auth/reset-password" element={<ResetPassword />} />*/}
			{/*<Route path="/auth/change-expired-password" element={<ChangeExpiredPassword />} />*/}
			{/* Protected routes */}
			<Route element={<ProtectedRoute />}>
				<Route path="/" element={<Navigate to="/contacts/search" replace />} />

				{/* Contacts */}
				<Route path="/contacts/search" element={<ContactSearch />} />
				<Route path="/contacts/profile/:id" element={<ContactProfile />} />
				<Route path="/contacts/create" element={<ContactCreate />} />
				<Route path="/contacts/edit/:id" element={<ContactEdit />} />
				<Route path="/contacts/company-profile/:id" element={<CompanyProfile />} />
				<Route path="/contacts/create-company" element={<CompanyCreate />} />
				<Route path="/contacts/company-edit/:id" element={<CompanyEdit />} />
				<Route path="/contacts/link-contact/:id" element={<LinkContact />} />
				<Route path="/contacts/link-company/:id" element={<LinkCompany />} />

				{/* Awards */}
				<Route path="/awards/search" element={<AwardsSearch />} />
				<Route path="/awards/create" element={<AwardsCreate />} />
				<Route path="/awards/edit/:id" element={<AwardsEdit />} />

				{/* Entries */}
				<Route path="/entries/search" element={<EntriesSearch />} />
				<Route path="/entries/profile/:id" element={<EntriesProfile />} />
				<Route path="/entries/finalists" element={<EntriesFinalists />} />
				<Route path="/entries/reveal" element={<EntriesReveal />} />
				<Route path="/entries/uploadAssets" element={<EntriesUploadAssets />} />

				{/* Judges */}
				<Route path="/judges/search" element={<JudgesSearch />} />

				{/* Nominations */}
				<Route path="/nominations/search" element={<NominationsSearch />} />
				<Route path="/nominations/view/:id" element={<NominationsView />} />

				{/* Enquiries */}
				<Route path="/enquiries/search" element={<EnquiriesSearch />} />
				<Route path="/enquiries/view/:id" element={<EnquiriesView />} />

				{/* Access */}
				<Route path="/access/employees" element={<EmployeesAccess />} />

				{/* Reports */}
				<Route path="/reports/summary-reports" element={<ReportsSummary />} />
			</Route>
			{/* Catch all */}
			<Route path="*" element={<Navigate to="/contacts/search" replace />} />
		</Routes>
	)
}
